import type { Component } from 'solid-js'
import { EditorRoot } from './editor/ui/editor_root'

const App: Component = () => {
  return <EditorRoot />
}

export default App
